import React, { useState } from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Input,
  Row,
  Spinner,
  Table,
} from "reactstrap"
import { useAPI } from "hooks/useAPI"

import SimpleBar from "simplebar-react"
import "simplebar-react/dist/simplebar.min.css"
import { useIndicadoresFiltrosStore } from "store/useIndicadoresFiltrosStore"

const Cliente = props => {
  const [anoEscolhido, setAnoEscolhido] = useState(0)

  const REPORT_ID = 20

  const fetchReports = useIndicadoresFiltrosStore(state => state.fetchReports)
  const filtrosSelecionados = useIndicadoresFiltrosStore(
    state => state.filtrosSelecionados
  )

  const { payload, error, isLoading } = useAPI(
    REPORT_ID,
    filtrosSelecionados,
    fetchReports
  )

  const anos = payload?.data?.response.map((item, idx) => {
    return {
      ano: item[0],
      valores: item.filter((e, i) => (i > 0) & (i < item.length - 1)),
      total: item[item.length - 1],
    }
  })

  const faixaLabels = [
    "Até 3 dias úteis",
    "De 4 a 5 dias úteis",
    "6 a 7 dias úteis",
    "8 a 10 dias úteis",
    "Acima de 10 dias úteis",
  ]

  const faixaColors = [
    { backgroundColor: "#ffffff" },
    { backgroundColor: "#bbe4d9" },
    { backgroundColor: "#80c1cc" },
    { backgroundColor: "#56abc0" },
    { backgroundColor: "#316c94" },
    { backgroundColor: "#2a5986" },
  ]

  const faixaCor = porcentagem => {
    if (porcentagem >= 80) {
      return faixaColors[5]
    }
    if (porcentagem >= 60) {
      return faixaColors[4]
    }
    if (porcentagem >= 40) {
      return faixaColors[3]
    }
    if (porcentagem >= 20) {
      return faixaColors[2]
    }
    if (porcentagem > 0) {
      return faixaColors[1]
    } else {
      return faixaColors[0]
    }
  }

  const ano =
    (anos !== undefined) & (anos?.length > 0) ? anos[anoEscolhido] : {}

  return (
    <Card>
      <CardHeader tag={"h4"} className="bg-transparent border-bottom">
        {!isLoading && (
          <Row className="hstack">
            <Col>
              {payload?.title} <b>{` - tempo geral`}</b>
            </Col>
            {Object.keys(ano).length > 0 && (
              <Col>
                <Input
                  className="form-control-sm float-end"
                  type="select"
                  style={{ width: "150px" }}
                  onChange={e => {
                    setAnoEscolhido(e.target.value)
                  }}
                >
                  {anos.map((item, idx) => {
                    return (
                      <option key={idx} value={idx}>
                        {item.ano}
                      </option>
                    )
                  })}
                </Input>
              </Col>
            )}
          </Row>
        )}
        {isLoading && <span className="placeholder col-3"></span>}
      </CardHeader>
      <CardBody>
        {isLoading && (
          <div className="mt-3" style={{ textAlign: "center" }}>
            <Spinner
              className="ms-2"
              style={{ width: "4rem", height: "4rem" }}
              color="primary"
            />
          </div>
        )}
        {!isLoading &&
          (Object.keys(ano).length > 0 ? (
            <SimpleBar style={{ overflowY: "hidden" }}>
              <Table className="table align-middle mb-0 table-sm">
                <thead>
                  <tr>
                    <th>&nbsp;</th>
                    <th colSpan="13" className="text-center">
                      {ano.ano}
                    </th>
                  </tr>
                  <tr>
                    <th>&nbsp;</th>
                    <th>Janeiro</th>
                    <th>Fevereiro</th>
                    <th>Março</th>
                    <th>Abril</th>
                    <th>Maio</th>
                    <th>Junho</th>
                    <th>Julho</th>
                    <th>Agosto</th>
                    <th>Setembro</th>
                    <th>Outubro</th>
                    <th>Novembro</th>
                    <th>Dezembro</th>
                    <th>Total geral</th>
                  </tr>
                </thead>
                <tbody>
                  {faixaLabels.map((faixa, idx) => {
                    return (
                      <tr key={"eficienciacliente-" + idx}>
                        <td>{faixa}</td>
                        <td
                          className="text-black"
                          style={faixaCor(ano.valores[0][idx]?.porcentagem)}
                        >
                          {`${ano.valores[0][idx]?.porcentagem}%`}
                        </td>
                        <td
                          className="text-black"
                          style={faixaCor(ano.valores[1][idx]?.porcentagem)}
                        >
                          {`${ano.valores[1][idx]?.porcentagem}%`}
                        </td>
                        <td
                          className="text-black"
                          style={faixaCor(ano.valores[2][idx]?.porcentagem)}
                        >
                          {`${ano.valores[2][idx]?.porcentagem}%`}
                        </td>
                        <td
                          className="text-black"
                          style={faixaCor(ano.valores[3][idx]?.porcentagem)}
                        >
                          {`${ano.valores[3][idx]?.porcentagem}%`}
                        </td>
                        <td
                          className="text-black"
                          style={faixaCor(ano.valores[4][idx]?.porcentagem)}
                        >
                          {`${ano.valores[4][idx]?.porcentagem}%`}
                        </td>
                        <td
                          className="text-black"
                          style={faixaCor(ano.valores[5][idx]?.porcentagem)}
                        >
                          {`${ano.valores[5][idx]?.porcentagem}%`}
                        </td>
                        <td
                          className="text-black"
                          style={faixaCor(ano.valores[6][idx]?.porcentagem)}
                        >
                          {`${ano.valores[6][idx]?.porcentagem}%`}
                        </td>
                        <td
                          className="text-black"
                          style={faixaCor(ano.valores[7][idx]?.porcentagem)}
                        >
                          {`${ano.valores[7][idx]?.porcentagem}%`}
                        </td>
                        <td
                          className="text-black"
                          style={faixaCor(ano.valores[8][idx]?.porcentagem)}
                        >
                          {`${ano.valores[8][idx]?.porcentagem}%`}
                        </td>
                        <td
                          className="text-black"
                          style={faixaCor(ano.valores[9][idx]?.porcentagem)}
                        >
                          {`${ano.valores[9][idx]?.porcentagem}%`}
                        </td>
                        <td
                          className="text-black"
                          style={faixaCor(ano.valores[10][idx]?.porcentagem)}
                        >
                          {`${ano.valores[10][idx]?.porcentagem}%`}
                        </td>
                        <td
                          className="text-black"
                          style={faixaCor(ano.valores[11][idx]?.porcentagem)}
                        >
                          {`${ano.valores[11][idx]?.porcentagem}%`}
                        </td>
                        <td
                          className="text-black"
                          style={faixaCor(ano.total[idx]?.porcentagem)}
                        >
                          {`${ano.total[idx]?.porcentagem}%`}
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </SimpleBar>
          ) : (
            <CardTitle className="text-center">
              Nenhum dado foi encontrado.
            </CardTitle>
          ))}
      </CardBody>
    </Card>
  )
}

Cliente.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(Cliente)
